// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: 100%;
  margin-top: -100px;
`;

export const MetaMaskContainer = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
  min-width: 450px;
  cursor: pointer;
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
`;
